import { DashboardFilterProvider } from "@/contexts/DashboardFilterContext";
import { usePeriodFilter } from "@/contexts/dashboard-filter-context";
import { PeriodSelector } from "@/components/dashboard-sales/PeriodSelector";
import { PersonSelector } from "@/components/dashboard-sales/PersonSelector";
import { SalesKpiCards } from "@/components/dashboard-sales/SalesKpiCards";
import { SalesPanels } from "@/components/dashboard-sales/SalesPanels";
import { SalesHallOfFame } from "@/components/dashboard-sales/SalesHallOfFame";
import { periodLabel } from "@/lib/dashboard-period";

/**
 * BF-focused sales dashboard (Sølvrev Dashboard / Revehiet). Measures created
 * and expected gross profit (BF), budget precision and profitability per
 * person/period — not revenue.
 *
 * F0 ships the shell: shared filter layer (period + person) + selectors. KPI
 * cards (F1), panels (F2) and Hall of Fame (F3) mount into the content region
 * below. RBAC gating is added in F5 (VIB-1107) — for now the route is open to
 * all signed-in users (F5.1: "start with full visibility for everyone").
 */
function SalesDashboardContent() {
  const { period } = usePeriodFilter();

  return (
    <div className="space-y-6 p-6">
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Salgsdashboard</h1>
          <p className="text-muted-foreground">
            GEEK, budsjettpresisjon og pipeline · {periodLabel(period)}
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <PersonSelector />
          <PeriodSelector />
        </div>
      </header>

      {/* F1 KPI-kort. Hall of Fame (F3) monteres under panelene. */}
      <section aria-label="KPI-kort">
        <SalesKpiCards />
      </section>

      {/* F2 paneler: leaderboard, feilbudsjettering, pipeline, beste/dårligste. */}
      <section aria-label="Paneler">
        <SalesPanels />
      </section>

      {/* F3 Hall of Fame — historiske rekorder (ignorerer periode/person). */}
      <section aria-label="Hall of Fame" className="space-y-3">
        <h2 className="text-lg font-semibold tracking-tight">Hall of Fame</h2>
        <SalesHallOfFame />
      </section>
    </div>
  );
}

export default function SalesDashboardPage() {
  return (
    <DashboardFilterProvider>
      <SalesDashboardContent />
    </DashboardFilterProvider>
  );
}
